import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, Output, QueryList, SimpleChange, ViewChild, ViewChildren, OnInit, OnChanges, AfterViewInit } from '@angular/core';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { NavigationExtras, Router } from '@angular/router';
import { GroupService } from '../group.service';
import { AppViewService } from '../../../../shared/services/tcm-hub-appview.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ShareGroupComponent } from '../../group-maintenance/share-group/share-group.component';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { PortfolioHubService } from '../../../../techopsv4/services/portfolioHubV4Service';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { SharedAuthService } from '../../../../shared/shared.auth.service';
import { take } from 'rxjs/operators';
import { NgClass } from '@angular/common';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatSelectionList, MatListOption } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { SearchPipe } from '../../../../shared/pipe/search.pipe';


@Component({
    selector: 'app-group-maintenance-table',
    templateUrl: './group-maintenance-table.component.html',
    styleUrls: ['./group-maintenance-table.component.scss'],
    imports: [NgClass, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCheckbox, MatCellDef, MatCell, MatSortHeader, MatMenuTrigger, MatMenu, MatInput, FormsModule, MatSelectionList, MatListOption, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, SearchPipe]
})
export class GroupMaintenanceTableComponent implements AfterViewInit, OnChanges, OnInit {

  displayedColumns: string[] = ['select', 'groupname', 'Group_Type', 'LONG_APP_NAME', 'Visibility', 'Action'];
  @Input() TABLE_CONFIG;
  @Input() dataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  @Input() oldDataSource: any[];
  @Output() rowsSelected: EventEmitter<any> = new EventEmitter();
  @Output() datachange: EventEmitter<any> = new EventEmitter();

  @Input() pageSize: number = 0;
  @Input() pageIndex: number = 0;
  @Input() searchString: string;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChildren(MatMenuTrigger) trigger: QueryList<MatMenuTrigger>;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @Output() sortChangeEvent: EventEmitter<any> = new EventEmitter();
  selection = new SelectionModel<any>(true, []);
  loggedusermail: any;
  applicationTable: ApplicationTable;
  applist: any = [];
  isAdminRole: any;

  groupNameFilterApplied : boolean = false;
  groupTypeFilterApplied : boolean = false;
  visibilityFilterApplied : boolean = false;
  searchValue: string;
  filterList: any;
  filValue = [];
  filterLists: any = [];
  Allfilter = [];
  Finalfilter = [];
  groupNameFilter = [];
  groupTypeFilter = [];
  visibilityFilter = [];
  selectedColumn: string;
  searchTxt: string;
  previousSelection = [];

  constructor(public dialog: MatDialog, private route: Router, private groupService: GroupService, private AppViewService: AppViewService, 
    private portfolioService: PortfolioHubService,private sharedAuthService: SharedAuthService) {

  }
  ngOnInit() {
    this.loggedusermail =
      JSON.parse(sessionStorage.getItem('loggedInUserEmail')) || JSON.parse(sessionStorage.getItem('loggedInUserEmail'));
    if (!sessionStorage.getItem('techaccessData')) {
      this.sharedAuthService.userAccessDataSource.pipe(take(1)).subscribe(accessData => {
        this.isAdminRole = this.sharedAuthService.checkAdminSGAccess();
      });
    } else {
      this.isAdminRole = this.sharedAuthService.checkAdminSGAccess();
    }
    
  }
  ngOnChanges(changes: { [searchString: string]: SimpleChange }) {
    this.selection.clear();
    if(this.selection.selected.length <= 0) {
      this.rowsSelected.emit([]);
    }
    if(this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
    if(changes['searchString']) {
        const change: string = changes['searchString'].currentValue;
        this.searchDataSet(change);
    }
  }
  ngAfterViewInit() {
    if(this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }
  searchDataSet(search) {
    if(this.dataSource) {
      this.dataSource.filterPredicate = function (record, filter) {
        return record.groupname.toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) !== -1;
      }
    }
    if(search || search=='') {
      this.dataSource.filter = search.trim().toLowerCase();
    }
  }
  filterDropdown(column) {
    this.selectedColumn = column;    
    this.searchValue = '';
    let index;

    if(column == 'groupname')
      index = 0;
    else if (column == 'Group_Type')
      index = 1;
    else if(column == 'Visibility')
      index = 2;

      this.trigger.toArray().forEach((item: MatMenuTrigger, i: number) => {
        if(i !== index && item.menuOpen) {
          item.closeMenu()
        }
      });

    if (column == 'groupname') {
      if (this.visibilityFilterApplied || this.groupTypeFilterApplied) {
        this.filterList = this.dataSource.data.map((item) => { return item.groupname });
      }
      else {
        this.filterList = this.oldDataSource.map((item) => { return item.groupname });
      }
      this.filValue = this.groupNameFilter;
      this.trigger.toArray()[0].openMenu();
    }
    if (column == 'Group_Type') {
      if (this.visibilityFilterApplied || this.groupNameFilterApplied) {
        this.filterList = this.dataSource.data.map((item) => { return item.Group_Type });
      }
      else {
        this.filterList = this.oldDataSource.map((item) => { return item.Group_Type });
      }
      this.filValue = this.groupTypeFilter;
      this.trigger.toArray()[1].openMenu();
    }
    if(column == 'Visibility') {
      if (this.groupTypeFilterApplied || this.groupNameFilterApplied) {
        this.filterList = this.dataSource.data.map((item) => { return item.Visibility });
      }
      else {
        this.filterList = this.oldDataSource.map((item) => { return item.Visibility });
      }
      this.filValue = this.visibilityFilter;
      this.trigger.toArray()[2].openMenu();
    }
    this.filterList = new Set([...this.filterList]);
    this.filterLists = Array.from(this.filterList);
  }

  selectionChange(event) {
    let newevent;
    
    if (this.selectedColumn == 'groupname') {
      this.Allfilter.forEach((a, i) => { if (a.column == 'groupname') this.Allfilter.splice(i, 1) });
      newevent = this.checkPrevious(event,this.groupNameFilter);
      if (newevent.source._value.length > 0) {
          this.groupNameFilter = newevent.source._value;
          this.Allfilter.push({ column: 'groupname', value: newevent.source._value }) 
      } else {
        this.groupNameFilter = [];
      }
      this.trigger.toArray()[0].openMenu();
    }

    if (this.selectedColumn == 'Group_Type') {
      this.Allfilter.forEach((a, i) => { if (a.column == 'Group_Type') this.Allfilter.splice(i, 1) });
      newevent = this.checkPrevious(event,this.groupTypeFilter);
      if (newevent.source._value.length > 0) {
        this.groupTypeFilter = newevent.source._value;
        this.Allfilter.push({ column: 'Group_Type', value: newevent.source._value }) 
      } else {
        this.groupTypeFilter = [];
      }
      this.trigger.toArray()[1].openMenu();
    }

    if(this.selectedColumn == 'Visibility') {
      this.Allfilter.forEach((a, i) => { if (a.column == 'Visibility') this.Allfilter.splice(i, 1) });
      newevent = this.checkPrevious(event,this.visibilityFilter);
      if (newevent.source._value.length > 0) {
        this.visibilityFilter = newevent.source._value;
        this.Allfilter.push({ column: 'Visibility', value: newevent.source._value }) 
      } else {
        this.visibilityFilter = [];
      }
      this.trigger.toArray()[2].openMenu();
    }
  }

  checkPrevious(event,prevArr:any = []) {
    this.previousSelection = prevArr;
    if (this.previousSelection && this.previousSelection.length > 0) {
      let isPrevValueUnselected = true;
      for (let i = 0; i < this.previousSelection.length; i++) {
        //If previous selection is in DropDownData and not in event then only add previous selection in Event Values(Server Side Search)
        const uncheckedElementName = event.options[0]._value;
        const unchekcedStatus = event.options[0]._selected;
        if (!(unchekcedStatus) && isPrevValueUnselected) { //check for unchecked elements
          if (this.previousSelection[i] == uncheckedElementName) //check for element which is unchecked
          {
            this.previousSelection.splice(i, 1);
            i--;
            isPrevValueUnselected = false;
          }
        } else if (this.filterLists.includes(this.previousSelection[i]) && event.source._value.length > 0
          && !event.source._value.includes(this.previousSelection[i]))  //Checked cond1
        {
          event.source._value.push(this.previousSelection[i]);
        }
      }
    }
    if (event.source._value.length == 0) {//Unchecked cond2: element is unchecked after search
      for (let i = 0; i < this.previousSelection.length; i++) {
        if (this.filterLists.includes(this.previousSelection[i])) {
          event.source._value.push(this.previousSelection[i]);
        }
      }
    }
    this.previousSelection = [... new Set(event.source._value)];
    return event
  }
  
  applyLocalFilter() {
    this.searchTxt = '';
    let filterdata = this.oldDataSource;
    this.Finalfilter.forEach((a, i) => { if (a.column == this.selectedColumn) this.Finalfilter.splice(i, 1) });
    this.Allfilter.forEach((element) => {
      if(element.column == this.selectedColumn) {
        this.Finalfilter.push(element);
      }
    });
    this.visibilityFilterApplied = false;
    this.groupNameFilterApplied = false;
    this.groupTypeFilterApplied = false;
    this.Finalfilter.forEach((e1) => {
      if (e1.column == 'groupname') {
        if (e1.value.length > 0) {
          filterdata = filterdata.filter((item) => e1.value.some(e => e == item.groupname));
          this.filterLists = filterdata.map((item) => { return item.groupname });
          this.groupNameFilterApplied = true;
          this.dataSource = new MatTableDataSource(filterdata);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.trigger.toArray()[0].closeMenu();
        }
      }

      if (e1.column == 'Group_Type') {
        if (e1.value.length > 0) {
          filterdata = filterdata.filter((item) => e1.value.some(e => e == item.Group_Type));
          this.filterLists = filterdata.map((item) => { return item.Group_Type });
          this.groupTypeFilterApplied = true;
          this.dataSource = new MatTableDataSource(filterdata);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.trigger.toArray()[1].closeMenu();
        }
      }

      if (e1.column == 'Visibility') {
        if (e1.value.length > 0) {
          filterdata = filterdata.filter((item) => e1.value.some(e => e == item.Visibility));
          this.filterLists = filterdata.map((item) => { return item.Visibility });
          this.visibilityFilterApplied = true;
          this.dataSource = new MatTableDataSource(filterdata);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.trigger.toArray()[2].closeMenu();
        }
      }
    });
    if (this.Finalfilter.length == 0) {
      this.dataSource.data = this.oldDataSource;
      this.dataSource.paginator = this.paginator;
    }
    if(this.trigger.toArray()[0]) {
      this.trigger.toArray()[0].closeMenu();
    }
    if(this.trigger.toArray()[1]) {
      this.trigger.toArray()[1].closeMenu();
    }
    if(this.trigger.toArray()[2]) {
      this.trigger.toArray()[2].closeMenu();
    }
  }

  clearLocalFilter() {
    this.searchTxt = '';
    this.previousSelection = [];
    if(this.trigger.toArray()[0]) {
      this.trigger.toArray()[0].closeMenu();
    }
    if(this.trigger.toArray()[1]) {
      this.trigger.toArray()[1].closeMenu();
    }
    if(this.trigger.toArray()[2]) {
      this.trigger.toArray()[2].closeMenu();
    }

    if (this.selectedColumn == 'groupname') {
      this.groupNameFilter = [];
      this.groupNameFilterApplied = false;
      this.Finalfilter.forEach((a, i) => { if (a.column == 'groupname') this.Finalfilter.splice(i, 1) });
      this.Allfilter.forEach((a, i) => { if (a.column == 'groupname') this.Allfilter.splice(i, 1) });
    }
    if (this.selectedColumn == 'Group_Type') {
      this.groupTypeFilter = [];
      this.groupTypeFilterApplied = false;
      this.Finalfilter.forEach((a, i) => { if (a.column == 'Group_Type') this.Finalfilter.splice(i, 1) });
      this.Allfilter.forEach((a, i) => { if (a.column == 'Group_Type') this.Allfilter.splice(i, 1) });
    }
    if(this.selectedColumn == 'Visibility') {
      this.visibilityFilter = [];
      this.visibilityFilterApplied = false;
      this.Finalfilter.forEach((a, i) => { if (a.column == 'Visibility') this.Finalfilter.splice(i, 1) });
      this.Allfilter.forEach((a, i) => { if (a.column == 'Visibility') this.Allfilter.splice(i, 1) });
    }
    this.applyLocalFilter();
  }

  clearallFilter() {
    if(this.trigger.toArray()[0]){
      this.trigger.toArray()[0].closeMenu();
    }
    if(this.trigger.toArray()[1]){
      this.trigger.toArray()[1].closeMenu();
    }
    if(this.trigger.toArray()[2]){
      this.trigger.toArray()[2].closeMenu();
    }

    this.groupNameFilterApplied = false;
    this.groupTypeFilterApplied = false;
    this.visibilityFilterApplied = false;
    this.Allfilter = [];
    this.Finalfilter = [];
    this.groupNameFilter = [];
    this.groupTypeFilter = [];
    this.visibilityFilter = [];
    this.dataSource.data = this.oldDataSource;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  navigateToSharePage(element, shareOrTransfer) {
    if(shareOrTransfer === 'Share'){
      this.groupService.Group_Key = element.Group_Key;

      const navigationExtras: NavigationExtras = {
        queryParams: { 'Group_Key': element.Group_Key,
                        'manageShare' : true }
      };
  
      this.route.navigate([{ outlets: { primary: 'maintenance/editGroup' }}], navigationExtras );
   
    } else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = true;
      dialogConfig.data = {
        title: shareOrTransfer,
        id: element.Group_Key,
        Author: element.Author,
        Sub_Author: element.Sub_Author,
        groupname: element.groupname
      };
      dialogConfig.width = '25%';
      dialogConfig.hasBackdrop = true;
      dialogConfig.panelClass = 'custom-modalbox';
      dialogConfig.height = '40%';
      dialogConfig.disableClose = true;
      dialogConfig.maxWidth = '75vw';
      dialogConfig.position = { right: '500px' }


      const dialogRef = this.dialog.open(ShareGroupComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        if(result) {
          this.datachange.emit(dialogConfig.data);
        }
      })

    }
  }

  
  sortData(event) {
    
    let sort: any[] = [];
    if (event.direction) {
      sort = [[event.active, event.direction]];
    }
    this.sortChangeEvent.emit(sort);
   
}
  editCondition(element){
    let delegates = [];
    if(element.delgates){
      delegates = element.delgates.split(',').map(element => element.trim());
      if(element.Author === this.loggedusermail){
        return true
      }
      if (delegates.includes(this.loggedusermail)) {
        return true
      } else if(element.Visibility === "Private" && element.Group_Type=="Platform"){
        return true
      } else if(element.Visibility === "Public" && element.Group_Type=="Platform"){
        return false
      } else{
        return false
      }
    }
    if(element.Author === this.loggedusermail){
      return true
    }else if(this.isAdminRole && element.Group_Type === 'Platform'){
      if(element.Author === this.loggedusermail) {
        return true
      }
    }else{
      return false
    }
  }
  disableConditn(element){
      if(element.Author === this.loggedusermail){
        return false
      }else{
        return true
      }
  }
  shareCondition(element) {
    if(element.delgates){
      if(element.Author === this.loggedusermail  && element.Visibility === 'Private' && element.Group_Type=='Platform'){
        return true
      }
      if(element.Visibility === 'Private' && element.Group_Type=='Platform'){
        return true
      }else{
        return false
      }
    }
    if (this.isAdminRole) {
      if (element.Author === this.loggedusermail && element.Visibility === 'Private') {
        return true;
      } else {
        return false;
      }
    } else if (element.Author === this.loggedusermail && !this.isAdminRole && element.Group_Type === 'Custom' && element.Visibility === 'Private') {
      return true
    } else {
      return false;
    }
  }
  transferCondition(element) {
    if(element.delgates){
      if(element.Author === this.loggedusermail){
        return true
      }else{
        return false
      }
    }
    if (this.isAdminRole) {
      if (element.Author === this.loggedusermail) {
        return true;
      } else {
        return false;
      }
    } else if (element.Author === this.loggedusermail && !this.isAdminRole && element.Group_Type === 'Custom') {
      return true
    } else {
      return false;
    }
  }

  appLength(element) {
    return element.length;
  }

  navigateToViewGroup(element) {
    this.getGroups(element);
  }

  getGroups(element) {
    JSON.parse(sessionStorage.getItem('loggedInUserEmail')) || JSON.parse(sessionStorage.getItem('loggedInUserEmail'));
    const data = {
      Group_Key: element.Group_Key
    };
    this.AppViewService.getgroup(JSON.stringify(data)).subscribe((res: any) => {
      

      res[0]['applications'].forEach((element) => {
        this.applist.push(this.applicationTable = {
          appId: element.ASK_GLOBAL_ID ? element.ASK_GLOBAL_ID : '000',
          applicationList: element.LONG_APP_NAME
        })
      });
      const navigationExtras: NavigationExtras = {
        queryParams: { 
          groupName: res[0].groupname,
          selectedgroupapplist: JSON.stringify(this.applist),
          sharedusers: res[0].Author,
          description: res[0].Group_Description,
          groupType: res[0].Group_Type,
          visibility: res[0].Visibility}
      };
  
      this.route.navigate([{ outlets: { primary: 'maintenance/viewGroup' } }],navigationExtras);
    }, (err) => {
      console.log(err);
    });
  }

  navigateToEditPage(element) {
    this.groupService.Group_Key = element.Group_Key;

    const navigationExtras: NavigationExtras = {
      queryParams: { 'Group_Key': element.Group_Key }
    };

    this.route.navigate([{ outlets: { primary: 'maintenance/editGroup' }}], navigationExtras);
  }
  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.filteredData.length;
    const groupsCreated=this.dataSource.filteredData.filter(row=>
      row.Author===this.loggedusermail
      );
    return (numSelected === numRows || numSelected===groupsCreated.length);

  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if(this.isAllSelected()) {
      this.selection.clear();
      this.rowsSelected.emit([]);
    }
    else{
      this.dataSource.filteredData.forEach(row=>{
        if(row.Author===this.loggedusermail)
        this.selection.select(row)}
        );
      this.rowsSelected.emit(this.selection.selected);
    }
  }
  selecttoggle(row) {
    this.selection.toggle(row);
    const rowsSelected = this.selection.selected;
    this.rowsSelected.emit(rowsSelected);
  }

  disableGlobalCheckBox(){
    if (this.dataSource) {
      const groupsCreated=this.dataSource.data.filter(row=>
        row.Author===this.loggedusermail
        );
      return (0===groupsCreated.length);
    }
    
  }

  groupClicked(element) {
    const grpData = { name: element.groupname,key: element.Group_Key};
    this.portfolioService.porfolioSelectedFromFinance = false;
    this.route.navigate([{ outlets: { primary: 'portfolio-hub' }}],{ queryParams: { 
        tab: 'group',
        subTab:'maintainance',
        data : JSON.stringify(grpData)
      }   
    });
  }
}

interface ApplicationTable {
  appId: any;
  applicationList: any;
}



